import { HisRule, SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { UniOption } from "../dao/UniOption";
import { new_ErrorAlert } from "./ExportManager";
import { HisBasic } from "./HisBasic";
import { HisRow, SpwkHisStep } from "./HisRow";
import { SpwkMetaTable } from "./SpwkMetaTable";


export class HisRowParser_既往病史_自覺症狀 {

  /**
  * @param step - 用來區分 是 4既往病史 或 6自覺症狀
  * @param 基本檔 - 產生 data_row 時需要填寫的基本資料
  * @param meta_table - 用來查詢的資料來源
  * 
  * @returns 
  */
  static ConvertToHisRow(step: SpwkHisStep, 基本檔: HisBasic, meta_table: SpwkMetaTable): HisRow {

    if (step.Chapter === SpwkUtilV3.CHAPTER_既往病史 || step.Chapter === SpwkUtilV3.CHAPTER_自覺症狀) {
      // pass;
    } else {
      throw new Error("必須是 既往病史 或 自覺症狀 !!!");
    }
    const data_row: HisRow = new HisRow(基本檔, step.HIS類別代碼);
    let gender: string = "";
    if (基本檔.性別 === "F") {
      gender = "女";
    } else if (基本檔.性別 === "M") {
      gender = "男";
    }
    data_row.項目 = "1"; // 既往病史 與 自覺症狀 都累積在同一題;
    const 結果 = HisRowParser_既往病史_自覺症狀.___ConvertTo一般疾病項目_結果欄位(meta_table, step, gender);
    data_row.結果 = 結果;

    const 備註 = HisRowParser_既往病史_自覺症狀.___ConvertTo一般疾病項目_備註欄位(meta_table, step);
    data_row.備註 = 備註;

    return data_row;
  }


  static ___ConvertTo一般疾病項目_結果欄位(meta_table: SpwkMetaTable, step: SpwkHisStep, gender: string) {
    //#region 處理 結果: "17,18,19,20"   
    let chapter_options = meta_table.FilterOptions_ByChapter(step.Chapter);
    // (目前先假定 整個 既往病史 與 自覺症狀 的選項都一定是疾病項目)
    // 如果不是，則未來在此檢查例外情形
    const his_code_list = [];

    for (const opt of chapter_options) {
      if (opt.q_his_rule !== HisRule.CH4 && opt.q_his_rule !== HisRule.CH6) {
        throw new_ErrorAlert("既往病史/自覺症狀 預期所有題目都是 CH4 或 CH6，但發現例外:" + opt.q_his_rule + " !!!\nopt_guid:" + opt.data_guid);
      }
      let rhf_value = opt.rhf_value;
      let check = (rhf_value === true);
      let option = opt.data_obj as UniOption;
      if (check && (option.gender_filter === gender || option.gender_filter === '')) {
        let his_code = opt.his_code;
        if (his_code == null || his_code.trim() === "") {
          throw new_ErrorAlert("勾選選項應該要有 HIS_CODE !!!\nopt_guid:" + opt.data_guid);
        }

        his_code_list.push(his_code);
      }
    }

    // 6841652: 有需要由小到大 或 嚴格依照什麼順序嗎?

    const 結果 = ToDistinctArray(his_code_list).join(',');

    return 結果;
    //#endregion
  }





  static ___ConvertTo一般疾病項目_備註欄位(meta_table: SpwkMetaTable, step: SpwkHisStep) {
    //#region  處理: 備註
    let chapter_inputs = meta_table.FilterInputs_ByChapter(step.Chapter);

    // data_row.備註 = "4_26#腎結石";
    const his_input_list = [];

    for (const input of chapter_inputs) {
      let rhf_value = input.rhf_value;
      if (rhf_value !== undefined && rhf_value !== '') {//yao rhf_value !== ''
        let his_code = input.his_code;

        if (his_code == null || his_code === "") {
          // 163543: TODO 4既往病史 或 6自覺症狀 確保每個選項都應該有 his_code，目前先隨機填一個不報錯，方便測試
          his_code = "<" + input.code + ">";
        }

        // 68464: TODO 疾病的 input 此處有勾或沒勾 有需要嚴格確認嗎

        his_input_list.push(his_code + "#" + rhf_value);
      }
    }

    const 備註 = ToDistinctArray(his_input_list).join('@');
    return 備註;

    //#endregion
  }


}

// ref: https://stackoverflow.com/questions/38206915/filter-array-to-have-unique-values
export function ToDistinctArray(arr: string[]) {
  var filteredArray = arr.filter(function (item, pos) {
    return arr.indexOf(item) === pos;
  });

  return filteredArray;

}